import { render } from "./SendAmountModal.vue?vue&type=template&id=7cefff48"
import script from "./SendAmountModal.vue?vue&type=script&lang=js"
export * from "./SendAmountModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__